import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useState, useReducer } from 'react';
import PropTypes from 'prop-types';
const initialState = {
  schema: [],
  visibleFilters: [],
  openFilters: {},
  openQuickFilters: {},
  extraSchema: [],
  updatedDefaultFilters: [],
  quickFilters: [],
  crossSchema: {},
  mappedSchema: {}
};
const reducer = (state, action) => {
  switch (action.type) {
    case 'init':
      return _objectSpread(_objectSpread({}, state), action.payload);
    case 'openFilters':
      return _objectSpread(_objectSpread({}, state), {}, {
        openFilters: action.payload
      });
    case 'openQuickFilters':
      return _objectSpread(_objectSpread({}, state), {}, {
        openQuickFilters: action.payload
      });
    case 'visibleFilters':
      return _objectSpread(_objectSpread({}, state), {}, {
        visibleFilters: action.payload
      });
    case 'quickFilters':
      return _objectSpread(_objectSpread({}, state), {}, {
        quickFilters: action.payload
      });
    case 'crossFilters':
      return _objectSpread(_objectSpread({}, state), {}, {
        crossSchema: action.payload
      });
    case 'saveConfig':
      return _objectSpread(_objectSpread({}, state), action.payload);
    default:
      return state;
  }
};
const FiltersContext = /*#__PURE__*/createContext();
const FiltersProvider = _ref => {
  let {
    children
  } = _ref;
  const [state, dispatch] = useReducer(reducer, initialState);
  const [clearFilters, setClearFilters] = useState(false);
  const [withExtraFields, setWithExtraFields] = useState(false);
  const [withActiveAdvancedFilters, setWithActiveAdvancedFilters] = useState(false);
  return /*#__PURE__*/React.createElement(FiltersContext.Provider, {
    value: {
      clearFilters,
      setClearFilters,
      withExtraFields,
      setWithExtraFields,
      withActiveAdvancedFilters,
      setWithActiveAdvancedFilters,
      state,
      dispatch
    }
  }, children);
};
const FiltersConsumer = FiltersContext.Consumer;
export { FiltersContext, FiltersProvider, FiltersConsumer };
process.env.NODE_ENV !== "production" ? FiltersProvider.propTypes = {
  children: PropTypes.node.isRequired
} : void 0;